import React, { useState, useContext } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import LanguageContext, { strings } from '../../contexts/language';
import { PiCheckCircleLight } from "react-icons/pi";

import api from '../../services/api';

export default function Inscricao() {
    const { language } = useContext(LanguageContext);
    const t = strings[language] || strings.pt;
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');
    const [form, setForm] = useState({
        name: '',
        email: '',
        phone: '',
        organization: '',
        role: '',
        age_range: '',
        race: '',
        gender: '',
        genre_other: '',
        accessibility: '',
        accessibility_text: '',
        dietary: '',
        participation_type: 'online',
    });

    const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

    function setType(v){
        if(v==="online"){
            set('accessibility', 'no');
            set('accessibility_text', '');
            set('dietary', '');
        }else{
            set('accessibility', '');
        }
    }

    async function submit(e) {
        e.preventDefault();
        if(form.participation_type==="online"){
            if (
                !form.name ||
                !form.email ||
                !form.organization ||
                !form.role ||
                !form.age_range ||
                !form.race ||
                !form.gender
            ) { setError(t.required_field); return; }
        }else{
            if (
                !form.name ||
                !form.email ||
                !form.organization ||
                !form.role ||
                !form.age_range ||
                !form.race ||
                !form.gender ||
                !form.accessibility
            ) { setError(t.required_field); return; }
        }

        setLoading(true); setError('');
        try {
            const payload = {
                ...form,
                gender: form.gender === 'gender_other' ? form.genre_other : form.gender,
                lang: language === 'en' ? 'en' : 'br',
            };
            const r = await api.post('/register', payload);
            if (!r.data.status) { setError(r.data.content); }
            else { setSuccess(true); }
        } catch(err) { setError(`${t.register_error}, ${err.message}`); }
        setLoading(false);
    }

    if (success) return (
        <div className="page"><Header />
            <main style={{ flex:1, display:'flex', alignItems:'center', justifyContent:'center', padding:'60px 20px' }}>
                <div style={{ maxWidth:500, textAlign:'center' }}>
                    <div style={{ fontSize:60, marginBottom:20 }} className="color_3"><PiCheckCircleLight size={80} /></div>
                    <h3 className="color_3">{t.register_success}</h3>
                </div>
            </main>
        <Footer /></div>
    );

    return (
        <div className="page">
            <Header />
            <main style={{ flex:1, padding:'40px 20px' }}>
                <div style={{ maxWidth:600, margin:'0 auto' }}>
                    <h2 className="section-title color_4 text-center">{t.register_title}</h2>
                    <h5 className="text-center text-danger fw-bold mb-10">
                        {language === 'en' ? 'IN-PERSON REGISTRATION - CLOSED ON THE WEBSITE' : 'INSCRIÇÕES PRESENCIAIS - ENCERRADAS NO SITE'}
                    </h5>
                    <p className="text-center mb-30">
                        {language === 'en' ? '(Registration for the in-person event is still open, but only at the event venue please arrive early—space is limited)' : '(Inscrições para o evento presencial seguem abertas, mas somente no local do evento - chegue com antecedência - vagas limitadas)'}
                    </p>

                    <form onSubmit={submit} className={loading ? 'loading' : ''}>
                        <div className="mb-20" style={{ width:'100%' }}>
                            <label>{t.register_participation} *</label>
                            <div className="options-subscribe">
                                {['online'].map(v => (
                                    <label key={v} style={{ display:'flex', alignItems:'center', gap:8, cursor:'pointer', fontWeight:600, whiteSpace: 'nowrap' }}>
                                        <input
                                            type="radio"
                                            name="participation_type"
                                            value={v}
                                            checked={form.participation_type === v}
                                            onChange={() => {
                                                set('participation_type', v);
                                                setType(v);
                                            }}
                                        />
                                        {v === 'online' ? t.register_online : t.register_presential}
                                    </label>
                                ))}
                            </div>
                        </div>

                        <Field label={`${t.register_name} *`}>
                            <input type="text" value={form.name} onChange={e => set('name', e.target.value)} required />
                        </Field>
                        <Field label={`${t.register_email} *`}>
                            <input type="email" value={form.email} onChange={e => set('email', e.target.value)} required />
                        </Field>
                        <Field label={`${t.register_phone}`}>
                            <input type="tel" value={form.phone} onChange={e => set('phone', e.target.value)} />
                        </Field>
                        <Field label={`${t.register_org} *`}>
                            <input type="text" value={form.organization} onChange={e => set('organization', e.target.value)} required />
                        </Field>
                        <Field label={`${t.register_role} *`}>
                            <input type="text" value={form.role} onChange={e => set('role', e.target.value)} required />
                        </Field>
                        <Field label={`${t.register_age} *`}>
                            <select value={form.age_range} onChange={e => set('age_range', e.target.value)} required>
                                <option value="">{t.select_placeholder}</option>
                                {['age_18_24','age_25_34','age_35_44','age_45_54','age_55_64','age_65_plus'].map(k =>
                                    <option key={k} value={t[k]}>{t[k]}</option>
                                )}
                            </select>
                        </Field>
                        <Field label={`${t.register_race} *`}>
                            <select value={form.race} onChange={e => set('race', e.target.value)} required>
                                <option value="">{t.select_placeholder}</option>
                                {['race_black','race_brown','race_white','race_indigenous','race_yellow','race_no_answer'].map(k =>
                                    <option key={k} value={t[k]}>{t[k]}</option>
                                )}
                            </select>
                        </Field>
                        <Field label={`${t.register_gender} *`}>
                            <select value={form.gender} onChange={e => set('gender', e.target.value)} required>
                                <option value="">{t.select_placeholder}</option>
                                {['gender_male','gender_female','gender_nonbinary','gender_other','gender_no_answer'].map(k =>
                                    <option key={k} value={t[k]}>{t[k]}</option>
                                )}
                            </select>
                        </Field>
                        {form.gender === 'gender_other' && (
                            <Field label={language === 'en' ? 'Describe: *' : 'Descreva *'}>
                                <input type="text" value={form.genre_other} onChange={e => set('genre_other', e.target.value)}required />
                            </Field>
                        )}

                        {form.participation_type === 'presencial' && (
                            <>
                            <Field label={`${t.register_accessibility} *`}>
                                <select value={form.disability} onChange={e => set('accessibility', e.target.value)} required>
                                    <option value="">{t.select_placeholder}</option>
                                    <option value="no">{language === 'en' ? 'No' : 'Não'}</option>
                                    <option value="yes">{language === 'en' ? 'Yes' : 'Sim'}</option>
                                </select>
                            </Field>
                            {form.accessibility === 'yes' && (
                                <Field label={language === 'en' ? 'Describe your need *' : 'Descreva sua necessidade *'}>
                                    <input type="text" value={form.accessibility_text} onChange={e => set('accessibility_text', e.target.value)}required />
                                </Field>
                            )}
                            <Field label={t.register_dietary}>
                                <input type="text" value={form.dietary} onChange={e => set('dietary', e.target.value)} />
                            </Field>
                        </>)}

                        {error && <div className="w-100 text-center error mb-20">{error}</div>}
                        <button type="submit" className="btn-send btn-modern w-100" disabled={loading}>
                            {loading ? (language === 'en' ? 'Sending...' : 'Enviando...') : t.btn_send}
                        </button>

                        <p className="home-lgpd-text mt-20">{t.register_lgpd}</p>
                    </form>
                </div>
            </main>
            <Footer />
        </div>
    );
}

function Field({ label, children }) {
    return (
        <div className="d-input mb-20" style={{ width:'100%' }}>
            <label>{label}</label>
            {children}
        </div>
    );
}
